import { render, staticRenderFns, recyclableRender, components } from "./index.vue?vue&type=template&id=5be48b23&scoped=true&"
var renderjs
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5be48b23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be48b23",
  null,
  false,
  components,
  renderjs
)

export default component.exports